import saveEditorData from '../../Common/saveEditorData';
import getEditorData from '../../Common/getEditorData';
import destroyEditorData from '../../Common/destroyEditorData';
import router from '../../../router/routes';

export default {
    namespaced: true,

    state: {
        cardId: '',
        helpTitle: '',
        helpText: '',
        name: '',
        order: 0,
        postData: [],
        published: false,
        route: '',
        sections: [],
        section: '',
        pages: [],
        page: '',
        types: [],
        type: '',
        deleteModal: false,
        fields: [],
        level: 'basic'
    },

    getters: {
        postData(state) {
            return {
                type: state.type,
                help_title: state.helpTitle,
                help_text: state.helpText,
                published: state.published,
                name: state.name,
                order: state.order,
                section_id: state.section,
                page_id: state.page,
                level: state.level,
            };
        },

        published(state) {
            return state.published;
        },

        publishedText(state) {
            if (state.published) {
                return 'Published';
            } else {
                return 'Not Published';
            }
        },

        route(state) {
            if (state.cardId) {
                return '/api/card/edit/' + state.cardId;
            } else {
                return '/api/card/create';
            }
        }
    },

    mutations: {
        setCardId(state, value) {
            state.cardId = value;
        },

        setLevel(state, value) {
            state.level = value;
        },

        setHelpText(state, value) {
            state.helpText = value;
        },

        setHelpTitle(state, value) {
            state.helpTitle = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setOrder(state, value) {
            state.order = value;
        },

        setPublished(state, value) {
            state.published = value;
        },

        setType(state, value) {
            state.type = value;
        },

        setTypes(state, value) {
            state.types = value;
        },

        setSection(state, value) {
            state.section = value;
        },

        setSections(state, value) {
            state.sections = value;
        },

        setPage(state, value) {
            state.page = value;
        },

        setPages(state, value) {
            state.pages = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        },

        setFields(state, value) {
            state.fields = value;
        }
    },

    actions: {
        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setCardId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);
            getEditorData(getters.route).then((response) => {
                commit('setSections', response.data.data.sections);
                commit('setPages', response.data.data.pages);
                commit('setTypes', response.data.data.types);
                const card = response.data.data.card;
                if (state.cardId) {
                    commit('setHelpText', card.help_text ? card.help_text : '');
                    commit('setHelpTitle', card.help_title ? card.help_title : '');
                    commit('setName', card.name ? card.name : '');
                    commit('setOrder', card.order ? card.order : 0);
                    commit('setPublished', card.published ? card.published : 0);
                    commit('setSection', card.section && card.section.id ? card.section.id : null);
                    commit('setPage', card.page_id ? card.page_id : null);
                    commit('setType', card.type ? card.type : null);
                    commit('setFields', card.field ? card.field : []);
                    commit('setLevel', card.level ? card.level : 'basic');
                    commit('overlay/toggle', false, { root: true });
                } else {
                    commit('setHelpText', '');
                    commit('setHelpTitle', '');
                    commit('setName', '');
                    commit('setOrder', 0);
                    commit('setPublished', 0);
                    commit('setSection', null);
                    commit('setPage', null);
                    commit('setType', null);
                    commit('setFields', []);
                    commit('setLevel', 'basic');
                    commit('overlay/toggle', false, { root: true });
                }
            });
        },

        saveData({ getters, commit }) {
            saveEditorData('card', getters.route, getters.postData)
                .then((cardId) => {
                    if (router.currentRoute.name === 'CardEdit') {
                        commit('overlay/toggle', false, { root: true });
                    } else {
                        router.push('/card/edit/' + cardId);
                    }
                })
                .catch(() => {});
        },

        destroyData({ state }) {
            destroyEditorData('/api/card/delete/' + state.cardId)
                .then(() => {})
                .catch(() => {});
        },
    },
};
